// extracted by mini-css-extract-plugin
export var errorIcon = "_pf-1";
export var nameLogo = "_pf-0";